import { Table as AntdTable } from 'antd';
import './Table.scss';

const { Column, ColumnGroup } = AntdTable;
const Table = ({ ...props }) => {
  return <AntdTable {...props} />;
};

export default Table;
export { Column, ColumnGroup };
